/*
 * File: PatientAppointmentApi.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Patient Appointment API calls
 */
import { Http } from "api/Http";

const Api = new Http("patients/1/patient");

class PatientAppointmentApi {
  constructor(api) {
    this.api = api;
  }

  getAppointments = async (patientId, filters) => {
    let res = await this.api.get("/" + patientId + "/appointments" + filters);
    return res.data || [];
  };

  getFollowUps = async patientId => {
    let res = await this.api.get("/" + patientId + "/followups");
    return res.data || [];
  };
}

const newApi = new PatientAppointmentApi(Api);
export default newApi;
